<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" (click)="close()">
  <div
    class="w-full max-w-[460px] rounded-lg bg-white p-8 shadow-xl"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
    (keydown)="onKeydown($event)">
    <div class="mb-6 flex items-center justify-between">
      <h2 class="text-xl font-medium text-gray-900">{{ isArabic() ? "متابعة حالة الاتصال" : "Call Follow-up" }}</h2>
      <button type="button" class="cursor-pointer text-gray-900" (click)="close()" aria-label="close">
        <app-cancel-icon />
      </button>
    </div>

    @if (loading()) {
      <app-loading />
    } @else if (loadError()) {
      <p class="my-6 text-sm text-red-600">
        {{ isArabic() ? "تعذر تحميل الأسباب" : "Failed to load reasons" }}
      </p>
    } @else {
      <div class="flex flex-col gap-3" role="radiogroup">
        @for (reason of reasons(); track reason.id; let i = $index) {
          <button
            type="button"
            role="radio"
            class="reason-option flex w-full cursor-pointer flex-row-reverse items-center justify-between gap-3 text-start text-sm outline-none"
            [class.reason-pending]="i === 0"
            [class.reason-later]="i === 1"
            [class.reason-not-needed]="i === 2"
            [class.reason-unavailable]="i === 3"
            [attr.aria-checked]="selectedIndex() === i"
            [attr.tabindex]="selectedIndex() === i ? 0 : -1"
            (click)="focusOption(i)">
            <span class="reason-label">{{ isArabic() ? reason.titleAr : reason.titleEn }}</span>
            <span class="reason-radio" [class.selected]="selectedIndex() === i"></span>
          </button>
        }
      </div>
    }

    <div class="my-6 flex flex-col gap-2">
      <label for="follow-up-comment" class="text-lg font-medium text-gray-900">
        {{ isArabic() ? "ملاحظات" : "Comments" }}
      </label>
      <textarea
        id="follow-up-comment"
        class="focus-border-black h-[6rem] w-full rounded-md border border-gray-400 bg-white px-3 py-2 text-sm outline-none"
        [placeholder]="isArabic() ? 'أدخل ملاحظاتك' : 'Enter your notes'"
        [value]="comment()"
        (input)="comment.set($any($event.target).value)"></textarea>
    </div>

    @if (errorMessage()) {
      <app-error class="mb-3 block" [apiError]="errorMessage()" />
    }

    <div class="flex justify-end gap-3">
      <div class="w-32">
        <app-submit-button type="secondary" class="block [&>button]:w-full" (click)="close()">
          {{ isArabic() ? "الغاء" : "Cancel" }}
        </app-submit-button>
      </div>
      <div class="w-32">
        <app-submit-button
          type="primary"
          [disabled]="loading() || loadError() || submitting() || !reasons().length"
          (click)="save()">
          {{ submitting() ? (isArabic() ? "جار الحفظ" : "Saving") : isArabic() ? "حفظ" : "Save" }}
        </app-submit-button>
      </div>
    </div>
  </div>
</div>
